import axios from 'axios';
const baseUrl = process.env.REACT_APP_SALES_API_URL;

export const createUser = (
  firstName,
  lastName,
  password,
  tenantId,
  email,
  countryCode,
  userCountryCode,
  stateId,
  city,
  postalCode,
  address,
  phone,
  activityId,
  jobTitle,
  company,
  rpId,
  rpCityId,
  language,
  token,
  welletContext,
) => {
  try {
    const response = welletContext.apis.tickets.post(
      `register/identity`,
      {
        firstName,
        lastName,
        password,
        Confirmation: password,
        tenantId,
        email,
        countryCode,
        userCountryCode,
        stateId,
        city,
        postalCode,
        address,
        phone,
        activityId,
        jobTitle,
        company,
        rpId,
        cityId: rpCityId,
        language,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const createSimpleUser = (
  firstName,
  lastName,
  userCountryCode,
  tenantId,
  email,
  marketCountryCode,
  language,
  token,
  welletContext,
  phone,
) => {
  try {
    const response = welletContext.apis.tickets.post(
      `register/simple`,
      {
        firstName,
        lastName,
        userCountryCode,
        tenantId,
        email,
        countryCode: marketCountryCode,
        language,
        phone,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const fetchAppStatus = async (jwt) => {
  try {
    return await axios.get(`${baseUrl}/associates/appstatus`, {
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    });
  } catch (e) {
    console.error(e);
    throw e;
  }
};
